import { Shield, Lock } from 'lucide-react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ROUTES } from '../constants';
import { Link } from 'react-router-dom';
import { LayoutWrapper } from '../components/LayoutWrapper';

const defaultMessages = defineMessages({
  'privacy.title': {
    id: 'privacy.title',
    defaultMessage: 'Политика конфиденциальности',
  },
  'privacy.subtitle': {
    id: 'privacy.subtitle',
    defaultMessage:
      'Мы заботимся о защите ваших персональных данных и обеспечиваем их безопасность',
  },
  'privacy.protectionTitle': {
    id: 'privacy.protectionTitle',
    defaultMessage: 'Защита ваших данных - наш приоритет',
  },
  'privacy.protectionDescription': {
    id: 'privacy.protectionDescription',
    defaultMessage:
      'Мы обеспечиваем полную прозрачность в вопросах обработки и защиты ваших персональных данных',
  },
  'privacy.contactTitle': {
    id: 'privacy.contactTitle',
    defaultMessage: 'Остались вопросы?',
  },
  'privacy.contactDescription': {
    id: 'privacy.contactDescription',
    defaultMessage:
      'Если у вас есть вопросы о нашей Политике конфиденциальности или обработке персональных данных, пожалуйста, свяжитесь с нами.',
  },
  'faq.contactButton': {
    id: 'faq.contactButton',
    defaultMessage: 'Связаться с поддержкой',
  },
  'privacy.section.0.title': {
    id: 'privacy.section.0.title',
    defaultMessage: '1. Общие положения',
  },
  'privacy.section.0.content': {
    id: 'privacy.section.0.content',
    defaultMessage:
      'Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сервиса NovoService.\nИспользуя наш сервис, вы принимаете условия данной Политики конфиденциальности и даете согласие на обработку ваших персональных данных.',
  },
  'privacy.section.1.title': {
    id: 'privacy.section.1.title',
    defaultMessage: '2. Собираемые данные',
  },
  'privacy.section.1.content': {
    id: 'privacy.section.1.content',
    defaultMessage:
      'Мы собираем следующие типы информации:\n• Личная информация (имя, email, телефон)\n• Профессиональная информация (опыт работы, специализация)\n• Данные о местоположении\n• Информация об использовании сервиса\n• Техническая информация (IP-адрес, тип устройства)\n• Файлы cookies',
  },
  'privacy.section.2.title': {
    id: 'privacy.section.2.title',
    defaultMessage: '3. Цели обработки данных',
  },
  'privacy.section.2.content': {
    id: 'privacy.section.2.content',
    defaultMessage:
      'Мы обрабатываем ваши данные для:\n• Предоставления доступа к сервису\n• Улучшения качества услуг\n• Персонализации пользовательского опыта\n• Обеспечения безопасности\n• Коммуникации с пользователями\n• Соблюдения законодательных требований',
  },
  'privacy.section.3.title': {
    id: 'privacy.section.3.title',
    defaultMessage: '4. Защита информации',
  },
  'privacy.section.3.content': {
    id: 'privacy.section.3.content',
    defaultMessage:
      'Мы применяем следующие меры для защиты ваших данных:\n• Шифрование данных при передаче\n• Регулярное обновление систем безопасности\n• Ограниченный доступ к персональным данным\n• Мониторинг и аудит систем безопасности\n• Физическая защита серверов',
  },
  'privacy.section.4.title': {
    id: 'privacy.section.4.title',
    defaultMessage: '5. Передача данных третьим лицам',
  },
  'privacy.section.4.content': {
    id: 'privacy.section.4.content',
    defaultMessage:
      'Мы можем передавать данные третьим лицам только в следующих случаях:\n• С вашего явного согласия\n• Для выполнения требований законодательства\n• Для обработки платежей (платежным системам)\n• Сервисам аналитики (в обезличенном виде)',
  },
  'privacy.section.5.title': {
    id: 'privacy.section.5.title',
    defaultMessage: '6. Права пользователей',
  },
  'privacy.section.5.content': {
    id: 'privacy.section.5.content',
    defaultMessage:
      'Вы имеете право:\n• Получать информацию об обработке ваших данных\n• Требовать исправления неточных данных\n• Требовать удаления ваших данных\n• Отозвать согласие на обработку данных\n• Ограничить обработку ваших данных\n• Получить копию ваших данных',
  },
  'privacy.section.6.title': {
    id: 'privacy.section.6.title',
    defaultMessage: '7. Файлы cookies',
  },
  'privacy.section.6.content': {
    id: 'privacy.section.6.content',
    defaultMessage:
      'Мы используем cookies для:\n• Аутентификации пользователей\n• Сохранения пользовательских настроек\n• Анализа использования сервиса\n• Персонализации контента\nВы можете отключить cookies в настройках браузера, но это может ограничить функциональность сервиса.',
  },
  'privacy.section.7.title': {
    id: 'privacy.section.7.title',
    defaultMessage: '8. Изменения политики',
  },
  'privacy.section.7.content': {
    id: 'privacy.section.7.content',
    defaultMessage:
      'Мы оставляем за собой право вносить изменения в данную Политику конфиденциальности. Актуальная версия всегда доступна на нашем сайте.',
  },
});

const sections = [
  { title: 'privacy.section.0.title', content: 'privacy.section.0.content' },
  { title: 'privacy.section.1.title', content: 'privacy.section.1.content' },
  { title: 'privacy.section.2.title', content: 'privacy.section.2.content' },
  { title: 'privacy.section.3.title', content: 'privacy.section.3.content' },
  { title: 'privacy.section.4.title', content: 'privacy.section.4.content' },
  { title: 'privacy.section.5.title', content: 'privacy.section.5.content' },
  { title: 'privacy.section.6.title', content: 'privacy.section.6.content' },
  { title: 'privacy.section.7.title', content: 'privacy.section.7.content' },
];

export function PrivacyPolicy() {
  return (
    <LayoutWrapper hasHero>
      <div className='bg-blue-600 text-white py-16'>
        <div className='container mx-auto px-4 text-center'>
          <Shield className='w-16 h-16 mx-auto mb-6' />
          <h1 className='text-4xl font-bold mb-4'>
            <FormattedMessage {...defaultMessages['privacy.title']} />
          </h1>
          <p className='text-xl text-blue-100 max-w-2xl mx-auto'>
            <FormattedMessage {...defaultMessages['privacy.subtitle']} />
          </p>
        </div>
      </div>

      <div className='container mx-auto px-4 py-12'>
        <div className='max-w-3xl mx-auto'>
          <div className='bg-white rounded-xl shadow-sm p-6 mb-8'>
            <div className='flex items-center space-x-4 mb-4'>
              <Lock className='w-8 h-8 text-blue-600' />
              <div>
                <h2 className='text-xl font-semibold'>
                  <FormattedMessage
                    {...defaultMessages['privacy.protectionTitle']}
                  />
                </h2>
                <p className='text-gray-600'>
                  <FormattedMessage
                    {...defaultMessages['privacy.protectionDescription']}
                  />
                </p>
              </div>
            </div>
          </div>

          {sections.map((section, index) => (
            <div
              key={index}
              className='bg-white rounded-xl shadow-sm p-6 mb-6 last:mb-0'
            >
              <h2 className='text-xl font-semibold mb-4'>
                <FormattedMessage {...defaultMessages[section.title]} />
              </h2>
              <div className='prose max-w-none text-gray-600'>
                <FormattedMessage {...defaultMessages[section.content]}>
                  {(message) => {
                    const [title, list] = String(message).split(':', 2);
                    const items = list
                      ? list
                          .split('•')
                          .map((item) => item.trim())
                          .filter(Boolean)
                      : [];

                    return (
                      <>
                        {title && (
                          <p className='mb-2'>
                            {title}
                            {!!list?.length && ':'}
                          </p>
                        )}
                        {items.length > 0 && (
                          <ul className='list-disc space-y-2 pl-5'>
                            {items.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        )}
                      </>
                    );
                  }}
                </FormattedMessage>
              </div>
            </div>
          ))}

          <div className='bg-blue-50 rounded-xl p-6 mt-8'>
            <h2 className='text-xl font-semibold mb-4'>
              <FormattedMessage {...defaultMessages['privacy.contactTitle']} />
            </h2>
            <p className='text-gray-600 mb-4'>
              <FormattedMessage
                {...defaultMessages['privacy.contactDescription']}
              />
            </p>
            <Link to={ROUTES.contact}>
              <button className='bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700'>
                <FormattedMessage {...defaultMessages['faq.contactButton']} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
}
